<script setup lang="ts">
import { ConfirmModal } from '@collector/shared-ui'
</script>

<template>
  <ConfirmModal>
    <template #title>
      Do you want to add a player without a shirt number?
    </template>
  </ConfirmModal>
</template>
